var l = (
  /** @class */
  function() {
    function i() {
      this.callbacks = {};
    }
    return i.prototype.on = function(t, n) {
      return this.callbacks[t] ? this.callbacks[t].push(n) : this.callbacks[t] = [n], this;
    }, i.prototype.once = function(t, n) {
      var r = this, o = function() {
        for (var a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        r.off(t, o), n.apply(r, a);
      };
      return this.on(t, o), this;
    }, i.prototype.off = function(t, n) {
      var r, o = (r = this.callbacks[t]) !== null && r !== void 0 ? r : [], a = o.filter(function(s) {
        return s !== n;
      });
      return this.callbacks[t] = a, this;
    }, i.prototype.emit = function(t) {
      for (var n = this, r, o = [], a = 1; a < arguments.length; a++)
        o[a - 1] = arguments[a];
      var s = (r = this.callbacks[t]) !== null && r !== void 0 ? r : [];
      return s.forEach(function(c) {
        c.apply(n, o);
      }), this;
    }, i;
  }()
);
export {
  l as Emitter
};
//# sourceMappingURL=index23.js.map
